module.exports = __webpack_public_path__ + "media/images/word-icon-e4ea40f62252e723d1a7939efe634a14.png";